/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportsUserViewCreateRequest {
    getFixupPrototypeFunction() { return ReportsUserViewCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<ReportsUserViewCreateRequest>): ReportsUserViewCreateRequest {
        let obj = Object.assign(new ReportsUserViewCreateRequest(), model);
        ReportsUserViewCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportsUserViewCreateRequest>): ReportsUserViewCreateRequest {
        if (!model) return null;
        return ReportsUserViewCreateRequest.newInstance(<ReportsUserViewCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportsUserViewCreateRequest) {
        if (!obj) return;

        models.ReportsUserViewCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportsUserViewCreateRequest): boolean {
        Object.setPrototypeOf(obj, ReportsUserViewCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the report
     */
    report_id: string;

    /**
     * Name of the View
     */
    view_name: string;

    /**
     * powerBI unique state id
     */
    state_id: string;

    /**
     * default view
     */
    default_view: boolean = false;

}
